import React from 'react';
import styles from './FaqRelated.module.scss';
import { useOutletContext } from 'react-router-dom';
import { getFaqsByIds } from '../../../Helpers';
import { AppConfig, Faq } from '../../../Models';
import { FaqList } from '../../../Components/FaqList/FaqList';

export interface FaqRelatedProps {
  ids: number[];
}

export const FaqRelated = ({
  ids
}: FaqRelatedProps): React.ReactElement<FaqRelatedProps> => {
  const config: AppConfig = useOutletContext<AppConfig>();
  const faqs: Faq[] = getFaqsByIds(config, ids);

  return (
    <div className={styles.faqRelated}>
      <h2 className={styles.title}>Related questions</h2>

      <FaqList className={styles.faqList} faqs={faqs} />
    </div>
  );
};
